import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Smmbanner from "../Page-section/social-media-marketing/Smmbanner";
import Smmprocess from "../Page-section/social-media-marketing/Smmprocess";
import { useSEO } from "../hooks/useSEO";

function Smm() {
  useSEO({
    title: "SEO Agency in Noida | Get More Traffic, Leads & Sales",
    description:
      "Get top rankings, more traffic, and quality leads with our expert SEO Agency in Noida. Proven strategies, affordable plans, and free consultation to grow your business online.",
    canonical: "https://empowerweb.in/social-media-marketing-services",
    ogTitle: "seo agency in Noida, best seo company in noida",
    ogDescription:
      "Boost your online visibility with proven SEO strategies. Get expert SEO services in Noida and Delhi NCR for sustainable growth.",
    keywords:
      "seo agency in Noida, search engine optimization company in Noida,best seo company in noida, seo expert in Noida, SEO Company in Noida",
  });
  return (
    <div>
      <div>
        <Header />
        <Navbar />
        <main>
          <Smmbanner />
          <Smmprocess />
        </main>
        <Footer />
      </div>
     
    </div>
  );
}

export default Smm;
